// Recuperação automática da sessão de RASTREAMENTO (pedido 2026-09-24: "o
// sistema está toda hora deslogando"). A sessão do Traccar (cookie
// JSESSIONID) morria em qualquer reinício do Traccar e o app mandava o
// usuário pro login, mesmo com a sessão do GPS Drive (refresh de 30 dias)
// perfeitamente válida. Aqui, antes de desistir, pede ao GPS Drive Backend
// uma sessão nova do Traccar pro PRÓPRIO usuário (POST /auth/traccar-session)
// — o usuário nem percebe.
import { GPSDRIVE_API_URL, gpsDrivePost, isGpsDriveImpersonating } from "@/lib/api/gpsdrive-client";

// Depois de uma falha, não tenta de novo por um tempo — senão cada 401 da
// rajada de polling dispararia outra tentativa.
const FAILURE_COOLDOWN_MS = 15_000;

let inFlight: Promise<boolean> | null = null;
let lastFailureAt = 0;
// Desligado durante o "Sair": uma chamada atrasada que tome 401 depois do
// DELETE /api/session nunca pode recriar a sessão de quem acabou de sair.
let enabled = true;

export function setTraccarSessionRecoveryEnabled(value: boolean): void {
  enabled = value;
}

export function recoverTraccarSession(): Promise<boolean> {
  // Durante "Logar como" a sessão do Traccar é a do alvo e tem fluxo
  // próprio de troca/restauração — nunca mexe nela daqui.
  if (!enabled || !GPSDRIVE_API_URL || isGpsDriveImpersonating()) return Promise.resolve(false);
  if (Date.now() - lastFailureAt < FAILURE_COOLDOWN_MS) return Promise.resolve(false);
  if (!inFlight) {
    inFlight = gpsDrivePost<void>("/api/v1/auth/traccar-session")
      .then(() => true)
      .catch(() => {
        lastFailureAt = Date.now();
        return false;
      })
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}
